class poseDetect {

	constructor(isGuest, hostVirtual)
		{
			this.pose1 = {};
			
			if ( isGuest || hostVirtual || window['onDemand'] )
				{
					if ( !window.posemedia || window.posemedia === undefined ) { window.posemedia = require('@mediapipe/pose'); }
					this.pose1 = new window.posemedia.Pose({locateFile: (file) => { return (window['applicationPath'] ? window['applicationPath']+'/build/' : '') + 'pose/'+file; }});

					this.pose1.setOptions({
					  modelComplexity: 1,
					  smoothLandmarks: true,
					  minDetectionConfidence: 0.5,
					  minTrackingConfidence: 0.5,
					  enableSegmentation: true,
					  smoothSegmentation: true
					});
					
					this.pose1.onResults((res) => { /* console.log('pose1 onResults', res); */ this.poseResults(res, this); });
					
					this.pose1.initialize();
				}
			
			this.pendingResult = false;
			
			this.callback = false;
			this.checkingDetection = false;
			this.checkingDetectionComplete = false;
			this.currentCanvas = false;
			this.currentContext = false;
			
			this.checkZone = [];
			
			this.currentRepeat = 0;
			this.poseDots = [];
		}
	
	poseResults(pose1, mainthis) {
		if ( !window['usingPose'] ) { return false; }
		
		//console.log('poseResults pose1', pose1);
		var points = [];
		if ( pose1 && pose1.poseLandmarks ) 
			{
				mainthis.pendingResult = false;
				mainthis.currentRepeat = 0;
				pose1.poseLandmarks.forEach(function(item){
					points.push({
						'x': item['x']*640,
						'y': item['y']*360
					});
				});
				
				if ( pose1.segmentationMask )
					{
						window['poseSegmentationMask'] = pose1.segmentationMask;
					}
				
				window['poseDots'] = points;
				this.poseDots = points;
				
				//console.log('poseResults points', points);
				if ( mainthis.callback ) { mainthis.callback(points); }
			}
		else if ( pose1 && pose1.image && mainthis.currentRepeat < 2 )
			{
				mainthis.currentRepeat++;
				mainthis.pose1.send({image: mainthis.currentCanvas});
			}
		else if ( mainthis.currentRepeat >= 2 )
			{
				mainthis.currentRepeat = 0;
				//console.log('poseResults points FAILED');
				mainthis.pose1.reset();
				mainthis.pendingResult = false;
				
				if ( mainthis.callback ) { mainthis.callback([]); }
			}
		
		//console.log('poseee', pose1);
	}
	
	getNewPose(canvasElement, callback) {
		if ( this.pendingResult ) { return false; }
		this.callback = callback;
		this.pendingResult = true;
		this.currentCanvas = canvasElement;
		
		this.pose1.send({image: this.currentCanvas});
	}
	
	getNewPoseAsync(canvasElement) {
		var mainthis = this;
		return new Promise(resolve => {
											mainthis.checkingDetection = true;
											mainthis.getNewPose(canvasElement, function(mod) {
												resolve(mod);
											});
											
											setTimeout(function() { /*console.log('timed out ---');*/ mainthis.pendingResult = false; resolve([]); }, 3000);
		});
	}
	
	checkDetection(canvasElement, detector) {
		
		if ( !detector[0] ) { window['poseDotsCross'] = detector['x']; }
		
		var mainthis = this;
		return new Promise(resolve => {
											mainthis.checkingDetection = true;
											mainthis.getNewPose(canvasElement, function(mod) {  
												var crossing = false;
												var crossing_multi = [];
												
												var pointMin = 640;
												var pointMax = 0;
												
												//console.log('checkDetection mod', mod);
												
												mod.forEach(function(item){
													if ( pointMin > item['x'] ) { pointMin = item['x']; }
													if ( pointMax < item['x'] ) { pointMax = item['x']; }
												});
												if ( !detector[0] )
													{
														detector['x'] = detector['x'] ? detector['x'] : detector['col0'];
														if ( mod.length == 0 || (pointMin < detector['x'] && pointMax > detector['x']) )
															{
																crossing = true;
															}
														//console.log('is crossing', crossing);
														resolve(crossing);
													}
												else
													{
														for (var a of detector )
															{
																var crossing = false;
																a['x'] = a['x'] ? a['x'] : a['col0'];
																if ( mod.length == 0 || (pointMin < a['x'] && pointMax > a['x']) )
																	{
																		crossing = true;
																	}
																crossing_multi.push(crossing);
															}
														
														//console.log('is crossing', crossing);
														resolve(crossing_multi);
													}
												
											});
											
											setTimeout(function() { /*console.log('timed out ---');*/ mainthis.pendingResult = false; resolve(-1); }, 3000);
		});
	}

	checkLowestPoint(canvasElement)
		{
			var mainthis = this;
			return new Promise(resolve => {
											if ( mainthis.pendingResult ) { resolve(false); return false; }
											
											if ( !this.useMediaPipe ) 
												{ 
													resolve(true); 
												}
											else
												{
													mainthis.getNewPose(canvasElement, function(mod) {
														var lowestPointY = 0;
														var lowestPointX = 0;
														
														mod.forEach(function(item){
															if ( lowestPointY < item['y'] ) { lowestPointY = item['y']; lowestPointX = item['x']; }
														});
														
														window['zoneLowestPoint'] = {'x': lowestPointX, 'y': lowestPointY};
														
														resolve(true);
													});
													
													setTimeout(function() { mainthis.pendingResult = false; resolve(false); }, 3000);
												}
			});
		}
		
	checkHighestPoint(canvasElement)
		{
			//console.log('pipe_fun');
			var mainthis = this;
			return new Promise(resolve => {
											//console.log('pipe_fun inside');
											if ( mainthis.pendingResult ) { resolve(false); return false; }
											
											//console.log('pipe_fun inside 111');
											if ( !this.useMediaPipe ) 
												{ 
													resolve(true); 
												}
											else
												{
													//console.log('pipe_fun inside 222');
													mainthis.getNewPose(canvasElement, function(mod) {
														var highestPointY = 0;
														var highestPointX = 0;
														
														mod.forEach(function(item){
															if ( highestPointY > item['y'] || highestPointY == 0 ) { highestPointY = item['y']; highestPointX = item['x']; }
														});
														//console.log('pipe_fun inside 333');
														window['zoneHighestPoint'] = {'x': highestPointX, 'y': highestPointY};
														
														resolve(true);
													});
													
													setTimeout(function() { mainthis.pendingResult = false; resolve(false); }, 3000);
												}
			});
		}
	
	checkInZone(canvasElement) {
		
		var mainthis = this;
		return new Promise(resolve => {
											if ( !mainthis.checkZone || !mainthis.checkZone[0] || !mainthis.checkZone[0]['ul_col'] || mainthis.pendingResult ) { resolve(true); return true; }
											
											mainthis.getNewPose(canvasElement, function(mod) {
												var lowestPointY = 0;
												var lowestPointX = 0;
												var highestPointY = 9999;
												var highestPointX = 0;
												var inZone = false;
												var feetPoints = [];
												var leftFoot = [];
												var rightFoot = [];
												var armPoints = [];
												var rightArm = [];
												var leftArm = [];
												
												//console.log('checkDetection mod2', mod);
												
												mod.forEach(function(item, index){
													if ( lowestPointY < item['y'] ) { lowestPointY = item['y']; lowestPointX = item['x']; }

													if ( highestPointY > item['y'] ) { highestPointY = item['y']; highestPointX = item['x']; }
													
													if ( index > 26 ) 
														{ 
															feetPoints.push({'x': item['x'], 'y': item['y']}); 
															if ( index == 27 || index == 29 || index == 31 ) 
																{
																	leftFoot.push({'x': item['x'], 'y': item['y']});	
																}
															else 
																{
																	rightFoot.push({'x': item['x'], 'y': item['y']});	
																}
														}
													
													if ( index > 12 && index < 23 )
														{
															armPoints.push({'x': item['x'], 'y': item['y']}); 
															if ( index == 11 || index == 13 || index == 15 || index == 17 || index == 19 || index == 21 )
																{
																	leftArm.push({'x': item['x'], 'y': item['y']});
																}
															else
																{
																	rightArm.push({'x': item['x'], 'y': item['y']});
																}
														}
												});
												
												if ( mod.length == 0 )
													{
														inZone = -1;
														console.log('checkInside inZone uppppp', inZone);
													}
												else
													{
														var checkPoints = [leftFoot, rightFoot];
														if ( window['globalActType'] != 'ladder' )  { checkPoints = [ lowestPointX, lowestPointY ]; }
														if ( window['globalActType'] == 'plankReach' || window['globalActType'] == 'plankForward' )  { checkPoints = [ leftArm, rightArm ] }
														mainthis.checkZone.forEach(function(zItem, zIndex){
															var zonePoints = [ [zItem['ul_col'], zItem['ul_row']], [zItem['ur_col'], zItem['ur_row']], [zItem['lr_col'], zItem['lr_row']], [zItem['ll_col'], zItem['ll_row']] ];
															var checkInsideZ =  mainthis.checkInside(checkPoints, zonePoints)
															inZone = inZone ? true : checkInsideZ;
															
															window['currentZoneActive'] = checkInsideZ ? zIndex+1 : window['currentZoneActive'];
														});
														
														//var zonePoints = [ [mainthis.checkZone['ul_col'], mainthis.checkZone['ul_row']], [mainthis.checkZone['ur_col'], mainthis.checkZone['ur_row']], [mainthis.checkZone['lr_col'], mainthis.checkZone['lr_row']], [mainthis.checkZone['ll_col'], mainthis.checkZone['ll_row']] ];
														
														//console.log('checkInside checkPoint', checkPoint);
														//console.log('checkInside zonePoints', zonePoints);
														
														//inZone = mainthis.checkInside(checkPoints, zonePoints);
														console.log('checkInside inZone', inZone);
													}
													
												/* console.log('checkInZone lowestPointX', lowestPointX);
												console.log('checkInZone lowestPointY', lowestPointY);
												console.log('checkInZone inZone', inZone); */
												
												window['zoneLowestPoint'] = {'x': lowestPointX, 'y': lowestPointY};
												window['zoneHighestPoint'] = {'x': highestPointX, 'y': highestPointY};
												
												resolve(inZone);
											});
											
											setTimeout(function() { mainthis.pendingResult = false; resolve(true); }, 3000);
		});
	}
	
	updateQuatZone(spec)
		{
			this.checkZone = spec['ul_col'] == undefined && spec[0] ? spec : [spec];
			
			/* if ( spec['ul_col'] )
				{
					this.checkZone = {'left': spec['ul_col'], 'right': spec['ur_col'], 'top': spec['ul_row'], 'bottom': spec['ll_row']};
				}
			else if ( spec['left'] )
				{
					this.checkZone = spec;
				} */
			
			window['poseSpaceCheck'] = this.checkZone;
		}
		
	checkInside(points, vs) {
		
		if ( window['globalActType'] == 'ladder' || window['globalActType'] == 'plankReach' || window['globalActType'] == 'plankForward' ) { var leftFoot = points[0]; var rightFoot = points[1]; }
		else { var x = points[0], y = points[1]; }
		window['leftFootInside'] = false;
		window['rightFootInside'] = false;
		//console.log('zone points', vs, points);
		
		var inside = false;
		for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
			var xi = vs[i][0], yi = vs[i][1];
			var xj = vs[j][0], yj = vs[j][1];
			if ( window['globalActType'] == 'ladder' || window['globalActType'] == 'plankReach' || window['globalActType'] == 'plankForward' )
				{
					for ( var b = 0; b < leftFoot.length; b++ )
						{
							var x = leftFoot[b].x;
							var y = leftFoot[b].y;
							
							var intersect = ((yi > y) != (yj > y))
								&& (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
							if (intersect) {inside = true; window['leftFootInside'] = true;}
						}
					//console.log('left33', window['leftFootInside']);
					for ( var a = 0; a < rightFoot.length; a++ )
						{
							var x2 = rightFoot[a].x;
							var y2 = rightFoot[a].y;
							
							var intersect2 = ((yi > y2) != (yj > y2))
								&& (x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi);
							if (intersect2) {inside = true;window['rightFootInside'] = true;}
						}
					//console.log('right33', window['rightFootInside']);
				}
			else
				{
					var intersect = ((yi > y) != (yj > y))
						&& (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
					if (intersect) inside = !inside;
				}
		}
		
		return inside;
	}
	
	reset() {
		this.pose1.reset();
	}
}

export default poseDetect;